import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <div className="section-header">
          <span className="section-number">[01]</span>
          <h2 className="section-title">
            <span className="glitch" data-text="SYSTEM_INFO">SYSTEM_INFO</span>
          </h2>
        </div>
        
        <div className="about-grid">
          <div className="about-card main-card">
            <div className="card-header">
              <span className="card-icon">{'>'}_</span>
              <span className="card-title">README.md</span>
            </div>
            <div className="card-body">
              <p className="code-text">
                <span className="keyword">const</span> <span className="variable">interests</span> = [<br/>
                &nbsp;&nbsp;<span className="string">"Mobil_Uygulama_Geliştirme"</span>,<br/>
                &nbsp;&nbsp;<span className="string">"Siber_Güvenlik"</span><br/>
                ];<br/><br/>
                
                <span className="comment">{'// SiberVatan programı mezunu'}</span><br/>
                <span className="keyword">while</span>(<span className="boolean">true</span>) {'{'}<br/>
                &nbsp;&nbsp;this.<span className="method">learn</span>();<br/>
                &nbsp;&nbsp;this.<span className="method">code</span>();<br/>
                &nbsp;&nbsp;this.<span className="method">improve</span>();<br/>
                {'}'}
              </p>
            </div>
          </div>

          <div className="about-card stats-card">
            <div className="stat-item">
              <div className="stat-label">FOCUS_AREAS</div>
              <div className="stat-value">02</div>
            </div>
            <div className="stat-item">
              <div className="stat-label">PROJECTS_LIVE</div>
              <div className="stat-value">02</div>
            </div>
            <div className="stat-item">
              <div className="stat-label">LEARNING_MODE</div>
              <div className="stat-value active">ON</div>
            </div>
          </div>
        </div>

        <div className="tech-tags">
          <span className="tag">#MobileDev</span>
          <span className="tag">#CyberSec</span>
          <span className="tag">#SiberVatan</span>
          <span className="tag">#CodeDaily</span>
        </div>
      </div>
    </section>
  );
};

export default About;
